module.exports = __webpack_public_path__ + "static/media/house-warming-card.7ad2d4fc.jpg";